<!-- Primary -->
<ng-container *ngIf="color === 'primary'" >
  <div class="md-select md-select__primary">
    <div class="d-flex justify-content-start align-items-center">
      <mat-form-field appearance="outline">
        <mat-label>{{label}}</mat-label>
        <mat-select class="md-select__select">
          <mat-option *ngFor="let item of data" [value]="item.id">
            {{item.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="color === 'primary-stroked'"> 
</ng-container>

<ng-container *ngIf="color === 'primary-text'">

</ng-container>
<ng-container *ngIf="color === 'primary-opacity'">
  
</ng-container>
<!-- Secondary -->
<ng-container  *ngIf="color === 'accent'">
</ng-container>

<ng-container *ngIf="color === 'accent-stroked'">
  
</ng-container>

<ng-container *ngIf="color === 'accent-text'">
  
</ng-container>
<ng-container *ngIf="color === 'accent-opacity'">
  
</ng-container>
<!-- Warn -->
<ng-container *ngIf="color === 'warn'">
</ng-container>

<ng-container *ngIf="color === 'warn-stroked'">
  
</ng-container>

<ng-container *ngIf="color === 'warn-text'">
  
</ng-container>
<ng-container *ngIf="color === 'warn-opacity'">
  
</ng-container>
<ng-template #buttonContent>
  <ng-content></ng-content>
</ng-template>